export const calculationInputQuery = `query CalculationInput($comparisonId: String!) {
    calculationInputHealthCare(comparisonId: $comparisonId) {
        policyPolicyDetails {
            paymentTermInMonths
            partyCaregivers {
                externalSourceName
            }
            coverageBasicHealths {
                deductibleAmount
            }
            partyPolicyHolders {
                addresses {
                    postalCode
                }
                genderOrLegalPersonType
                birthDate
                partyPartners {
                    genderOrLegalPersonType
                    birthDate
                }
                partyChildren {
                    genderOrLegalPersonType
                    birthDate
                }
            }
            healthAdditionalCoverages {
                key
                level
            }
        }
    }
}`;
